import './App.css';
import { Home } from './screens/Home';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { useIsPlayerOnly } from "./hooks/useIsPlayerOnly";
import { Login } from './components/Login';
import { LoginClub } from './components/LoginClub';
import AttendanceAnalytics from "./screens/AttendanceAnalytics";
import { EditPlayer } from "./screens/EditPlayer";
import Navbar from './components/Navbar';
import { Signup } from './components/Signup';
import { Dashboard } from './screens/Dashboard';
import { Footer } from './components/Footer';
import { MyTeam } from './screens/MyTeam';
import { CreateMatch } from './screens/CreateMatch';
import { MatchStats } from './screens/MatchStats';
import { BlockTemplates } from "./screens/BlockTemplates";
import { PlaybookEditor } from "./screens/PlaybookEditor";
import { AllMatches } from './screens/AllMatches';
import { MatchDetails } from './screens/MatchDetails';
import { PlayerSeasonStats } from './components/PlayerSeasonStats';
import { PlayerRadar } from './screens/PlayerRadar';
import { News } from "./screens/News";
import { CreateNews } from './screens/CreateNews';
import { EditNews } from "./screens/EditNews";
import { EditStats } from './screens/EditStats';
import { EditTeam } from "./screens/EditTeam";
import { MatchCalendar } from "./screens/MatchCalendar";
import { ResetPassword } from "./screens/ResetPassword";
import { UpdatePassword } from "./screens/UpdatePassword";
import { EditMatch } from "./screens/EditMatch";
import { ModMatch } from "./screens/ModMatch";
import { AddPodcast } from "./screens/AddPodcast";
import { PodcastPage } from "./screens/PodcastPage";
import { PlayerPage } from "./screens/PlayerPage";
import { LiveStats } from "./screens/LiveStats";
import { RotationManager } from "./screens/RotationManager";
import { Rotations } from "./screens/Rotations";
import { RotationPlanner } from "./screens/RotationPlanner";
import { PlayCreator } from './screens/PlayCreator';
import { Profile } from './screens/Profile';
import { EditProfile } from './screens/Edit-Profile';
import { PlayDetails } from './screens/PlayDetails';
import { AllPlays } from './screens/AllPlays';
import { CommunityPlays } from './screens/CommunityPlays';
import { ProfilePublic } from './screens/ProfilePublic';
import { Premium } from './screens/Premium';
import { Resources } from './screens/Ressources';
import { SharedPlay } from './screens/Sharedplay';
import { EditPlay } from './screens/EditPlay';
import { GlossaireStats } from "./screens/GlossaireStats";
import { TeamStats } from './screens/TeamStats';
import { Playbooks } from "./screens/Playbooks";
import { AddPlayer } from './screens/AddPlayer';
import { CreateTraining } from './screens/CreateTraining';
import { AllTrainings } from "./screens/AllTrainings";
import { PlanTraining } from './screens/PlanTraining';
import { TrainingDetails } from './screens/TrainingDetails';
import ProfileOnboardingGate from "./providers/ProfileOnboardingGate";
import { Features } from './screens/Features';
import MentionsLegales from './screens/MentionsLegales';
import ReglesUtilisation from './screens/ReglesUt';
import { Pricing } from './screens/PricingPage';
import CreateTeam from './screens/CreateTeam';
import { TeamPlayers } from './screens/TeamPlayers';
import Upgrade from './screens/Upgrade';
import Cancel from './screens/Cancel';
import { PlaybookDetails } from "./screens/PlaybookDetails";
import Success from './screens/Success';
import { BillingPortal } from "./screens/BillingPortal";
import { PlanDetails } from "./screens/PlanDetails";
import { PrivateRoute } from "./components/PrivateRoute";
import { TournamentPage } from './screens/TournamentPage';
import TournamentAdmin from './screens/TournamentAdmin';
import CreateTournament from './screens/CreateTournament';
import TournamentHub from "./screens/TournamentHub";
import ShootingTotals from "./screens/ShootingTotals";
import AcceptInvite from './screens/AcceptInvite';
import AcceptPlayerInvite from './screens/AcceptPlayerInvite';
import { ClubArticlePublisher } from "./screens/ClubArticlePublisher";
import ClubLayout from './Layouts/ClubLayouts';
import ClubDashboard from './screens/ClubDashboard';
import ClubMembers from './screens/ClubMembers';
import ClubPosts from './screens/ClubPosts';
import ClubTeams from './screens/ClubTeams';
import ClubTeamCreate from './screens/ClubTeamCreate';
import ClubSettings from './screens/ClubSettings';
import TeamFeed from './screens/TeamFeed';
import TeamLayout from './Layouts/TeamLayouts';
import TeamCalendar from "./screens/TeamCalendar";
import TeamMembers from "./screens/TeamMembers";
import ClubTeamStats from "./screens/ClubTeamStats";
import TeamTrainingDetails from './screens/TeamTrainingDetails';
import TeamMatchDetails from './screens/TeamMatchDetails';
import TeamSettings from './screens/TeamSettings';
import TeamEvents from './screens/TeamEvents';
import CreateClub from './screens/CreateClub';
import AdminAddClubMember from './screens/AdminAddClubMember';
import AdminAppAdmins from './screens/AdminAppAdmins';
import AcceptClubInvitation from './screens/AcceptClubInvitation';
import AuthCallback from './screens/AuthCallback';
import MyTeamsRedirect from './screens/MyTeamRedirect';
import MesEquipesHub from "./screens/MesEquipesHub";
import TeamChat from "./screens/TeamChat";
import ClubMatches from "./screens/ClubMatches";
import ClubTrainings from "./screens/ClubTrainings";
import ClubMatchDetails from "./screens/ClubMatchDetails";
import ClubTrainingDetails from "./screens/ClubTrainingDetails";
import { ArchivedTeams } from "./screens/ArchivedTeams";
import NotificationSettings from "./screens/NotificationSettings";
import NotificationsProvider from "./providers/NotificationsProvider";
import CoachChatFab from "./components/CoachChatFab";
import RevenueCatSync from "./components/RevenueCatSync";
import { pushHistoryEntry } from "./lib/navHistoryStack";

function NavHistoryTracker() {
  const location = useLocation();
  useEffect(() => {
    pushHistoryEntry(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function PlayerRestrictedRoute({ children }: { children: React.ReactNode }) {
  const { isPlayerOnly, loading } = useIsPlayerOnly();
  if (loading) return null;
  if (isPlayerOnly) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

function RootRoute() {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (mounted) {
        setIsAuth(!!user);
        setLoading(false);
      }
    })();

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuth(!!session?.user);
      setLoading(false);
    });
    return () => {
      mounted = false;
      sub.subscription?.unsubscribe();
    };
  }, []);

  if (loading) return null;
  if (isAuth) return <Navigate to="/dashboard" replace />;
  return <Home />;
}

function AppShell() {
  const location = useLocation();

  const isClubApp = location.pathname.startsWith("/club/");
  const isClubInviteFlow = location.pathname.startsWith("/invite/");
  const isAuthCallback = location.pathname.startsWith("/auth/callback");
  const isCoachChatRoute = /^\/myteam\/[^/]+\/messages\/?$/.test(location.pathname);
  const isFullScreenEditorRoute =
    location.pathname === "/playcreator" || /^\/editplay\/[^/]+\/?$/.test(location.pathname);

  const searchParams = new URLSearchParams(location.search);
  const redirectParam = searchParams.get("redirect") || "";
  const isClubRedirectFlow = redirectParam.startsWith("/invite/");

  const disableCoachOnboarding =
    isClubApp || isClubInviteFlow || isAuthCallback || isClubRedirectFlow;

  const showChrome = !isClubApp;
  const showFooter = showChrome && !isCoachChatRoute && !isFullScreenEditorRoute;

  return (
    <div className="app-shell">
      <NavHistoryTracker />
      <RevenueCatSync />
      <NotificationsProvider />
      <ProfileOnboardingGate disabled={disableCoachOnboarding}>
        {showChrome && (
          <div className="app-top">
            <div className="app-container">
              <Navbar />
            </div>
          </div>
        )}
        <main className="app-content">
          <Routes>
            {/* Public routes */}
            <Route path='/' element={<RootRoute />} />
            <Route path='/Contact' element={<Contact />} />
            <Route path='/About' element={<About />} />
            <Route path='/login' element={<Login />} />
            <Route path='/loginclub' element={<LoginClub />} />
            <Route path='/Signup' element={<Signup />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path='/update-password' element={<UpdatePassword />} />
            <Route path="/invite/:token" element={<AcceptClubInvitation />} />
            <Route path='/sharedplay/:id' element={<SharedPlay />} />
            <Route path='/features' element={<Features />} />
            <Route path='/rules' element={<ReglesUtilisation />} />
            <Route path='/legal' element={<MentionsLegales />} />
            <Route path='/pricing' element={<Pricing />} />
            <Route path='/tournaments/:id' element={<TournamentPage />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/accept-player-invite/:token" element={<AcceptPlayerInvite />} />
            <Route path="/club/:clubId" element={<ClubLayout />}>
              <Route path="dashboard" element={<ClubDashboard />} />
              <Route path="members" element={<ClubMembers />} />
              <Route path="posts" element={<ClubPosts />} />
              <Route path="mes-equipes" element={<MesEquipesHub />} />
              <Route path="teams" element={<ClubTeams />} />
              <Route path="teams/new" element={<ClubTeamCreate />} />
              <Route path="matches" element={<ClubMatches />} />
              <Route path="matches/:matchId" element={<ClubMatchDetails />} />
              <Route path="trainings" element={<ClubTrainings />} />
              <Route path="trainings/:trainingId" element={<ClubTrainingDetails />} />
              <Route path="settings" element={<ClubSettings />} />
              <Route path="my-teams" element={<MyTeamsRedirect />} />
              <Route path="team/:teamId" element={<TeamLayout />}>
                <Route index element={<TeamFeed />} />
                <Route path="events" element={<TeamEvents />} />
                <Route path="calendar" element={<TeamCalendar />} />
                <Route path="members" element={<TeamMembers />} />
                <Route path="stats" element={<ClubTeamStats />} />
                <Route path="messages" element={<TeamChat />} />
                <Route path="settings" element={<TeamSettings />} />
                <Route path="calendar/:trainingId" element={<TeamTrainingDetails />} />
                <Route path="calendar/match/:matchId" element={<TeamMatchDetails />} />
              </Route>
            </Route>
            



            {/* Private routes */}
            <Route path="/club-article" element={<PrivateRoute><ClubArticlePublisher /></PrivateRoute>} />
            <Route path='/Dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path='/tournaments/:id/admin' element={<PrivateRoute><TournamentAdmin /></PrivateRoute>} />
            <Route path="/club/create" element={<PrivateRoute><CreateClub /></PrivateRoute>} />
            <Route path="/admin/club-members/add" element={<PrivateRoute><AdminAddClubMember /></PrivateRoute>} />
            <Route path="/admin/app-admins" element={<PrivateRoute><AdminAppAdmins /></PrivateRoute>} />
            <Route path='/tournaments' element={<PrivateRoute><TournamentHub /></PrivateRoute>} />
            <Route path='/createtournament' element={<PrivateRoute><CreateTournament /></PrivateRoute>} />
            <Route path='/myteam' element={<PrivateRoute><MyTeam /></PrivateRoute>} />
            <Route
              path='/myteam/:teamId/messages'
              element={
                <PrivateRoute>
                  <div
                    className="max-w-3xl mx-auto px-3 sm:px-6"
                    style={{ ["--chat-offset" as any]: "175px" }}
                  >
                    <TeamChat />
                  </div>
                </PrivateRoute>
              }
            />
            <Route path='/glossaire-stats' element={<PrivateRoute><GlossaireStats /></PrivateRoute>} />
            <Route path='/creatematch' element={<PrivateRoute><CreateMatch /></PrivateRoute>} />
            <Route path='/matchstats' element={<PrivateRoute><MatchStats /></PrivateRoute>} />
            <Route path='/allmatchs' element={<PrivateRoute><AllMatches /></PrivateRoute>} />
            <Route path='/matchdetails/:id' element={<PrivateRoute><MatchDetails /></PrivateRoute>} />
            <Route path='/seasonstats' element={<PrivateRoute><PlayerSeasonStats /></PrivateRoute>} />
            <Route path='/playerradar/:number' element={<PrivateRoute><PlayerRadar /></PrivateRoute>} />
            <Route path='/news' element={<PrivateRoute><News /></PrivateRoute>} />
            <Route path='/createnews' element={<PrivateRoute><CreateNews /></PrivateRoute>} />
            <Route path='/editnews/:id' element={<PrivateRoute><EditNews /></PrivateRoute>} />
            <Route path='/editstats/:id' element={<PrivateRoute><EditStats /></PrivateRoute>} />
            <Route path='/matchcalendar' element={<PrivateRoute><MatchCalendar /></PrivateRoute>} />
            <Route path='/billing/portal' element={<PrivateRoute><BillingPortal /></PrivateRoute>} />
            <Route path='/editmatch/:id' element={<PrivateRoute><EditMatch /></PrivateRoute>} />
            <Route path='/modmatch/:id' element={<PrivateRoute><ModMatch /></PrivateRoute>} />
            <Route path='/podcast' element={<PrivateRoute><PodcastPage /></PrivateRoute>} />
            <Route path='/addpodcast' element={<PrivateRoute><AddPodcast /></PrivateRoute>} />
            <Route path='/player/:number' element={<PrivateRoute><PlayerPage /></PrivateRoute>} />
            <Route path='/player/by-id/:playerId' element={<PrivateRoute><PlayerPage /></PrivateRoute>} />
            <Route path='/livestats/:match_id' element={<PrivateRoute><LiveStats /></PrivateRoute>} />
            <Route path='/rotations' element={<PrivateRoute><PlayerRestrictedRoute><Rotations /></PlayerRestrictedRoute></PrivateRoute>} />
            <Route path='/rotations/plan/:plan_id' element={<PrivateRoute><PlayerRestrictedRoute><RotationPlanner /></PlayerRestrictedRoute></PrivateRoute>} />
            <Route path='/rotations/:match_id' element={<PrivateRoute><PlayerRestrictedRoute><RotationManager /></PlayerRestrictedRoute></PrivateRoute>} />
            <Route path="/playbooks/new" element={<PrivateRoute><PlaybookEditor mode="create" /></PrivateRoute>} />
            <Route path="/playbooks/:id" element={<PrivateRoute><PlaybookEditor mode="edit" /></PrivateRoute>} />
            <Route path='/editplayer/:playerId' element={<PrivateRoute><EditPlayer /></PrivateRoute>} />
            <Route path='/playcreator' element={<PrivateRoute><PlayerRestrictedRoute><PlayCreator /></PlayerRestrictedRoute></PrivateRoute>} />
            <Route path="/playbooksdetails/:id" element={<PrivateRoute><PlaybookDetails /></PrivateRoute>} />
            <Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path='/profile/notifications' element={<PrivateRoute><NotificationSettings /></PrivateRoute>} />
            <Route path='/edit-profile' element={<PrivateRoute><EditProfile /></PrivateRoute>} />
            <Route path='/play/:id' element={<PrivateRoute><PlayDetails /></PrivateRoute>} />
            <Route path='/allplays' element={<PrivateRoute><AllPlays /></PrivateRoute>} />
            <Route path='/complays' element={<PrivateRoute><CommunityPlays /></PrivateRoute>} />
            <Route path='/profile/:id' element={<PrivateRoute><ProfilePublic /></PrivateRoute>} />
            <Route path='/premium' element={<PrivateRoute><Premium /></PrivateRoute>} />
            <Route path='/plandetails' element={<PrivateRoute><PlanDetails /></PrivateRoute>} />
            <Route path='/resources' element={<PrivateRoute><Resources /></PrivateRoute>} />
            <Route path='/editplay/:id' element={<PrivateRoute><PlayerRestrictedRoute><EditPlay /></PlayerRestrictedRoute></PrivateRoute>} />
            <Route path='/teamstats' element={<PrivateRoute><TeamStats /></PrivateRoute>} />
            <Route path='/editteam/:id' element={<PrivateRoute><EditTeam /></PrivateRoute>} />
            <Route path='/addplayer/:id' element={<PrivateRoute><AddPlayer /></PrivateRoute>} />
            <Route path='/createtraining' element={<PrivateRoute><CreateTraining /></PrivateRoute>} />
            <Route path='/trainings' element={<PrivateRoute><AllTrainings /></PrivateRoute>} />
            <Route path='/plantraining' element={<PrivateRoute><PlanTraining /></PrivateRoute>} />
            <Route path='/training/:id' element={<PrivateRoute><TrainingDetails /></PrivateRoute>} />
            <Route path='/attendance' element={<PrivateRoute><AttendanceAnalytics /></PrivateRoute>} />
            <Route path='/block-templates' element={<PrivateRoute><BlockTemplates /></PrivateRoute>} />
            <Route path="/playbooks" element={<PrivateRoute><Playbooks /></PrivateRoute>} />
            <Route path='/teams/new' element={<PrivateRoute><CreateTeam /></PrivateRoute>} />
            <Route path='/teams/:teamId/players' element={<PrivateRoute><TeamPlayers /></PrivateRoute>} />
            <Route path='/upgrade' element={<PrivateRoute><Upgrade /></PrivateRoute>} />
            <Route path='/success' element={<PrivateRoute><Success /></PrivateRoute>} />
            <Route path='/cancel' element={<PrivateRoute><Cancel /></PrivateRoute>} />
            <Route path="/shooting-totals" element={<PrivateRoute><ShootingTotals /></PrivateRoute>} />
            <Route path="/archived-teams" element={<PrivateRoute><ArchivedTeams /></PrivateRoute>} />
          </Routes>
        </main>
        {showFooter && (
          <div className="app-container">
            <Footer />
          </div>
        )}
        {showChrome && <CoachChatFab />}
      </ProfileOnboardingGate>
    </div>
  );
}

export default function App() {
  return <AppShell />;
}

